import React, { useCallback } from 'react';
import { JqueryClassFaker } from '../../../components/JqueryClassFaker';
import LoadBar from 'react/elements/LoadBar';
import withDefaultProps from 'functions/withDefaultProps';

export default function UserlistHeaderSection(incomingProps) {
	const props = withDefaultProps(incomingProps, defaultProps);
	const sectionClick = useCallback((e) => {
		props.sectionClick(props.section, e);
	}, [props.sectionClick, props.section]);

	const { section, style, loading } = props;
	const classes = new JqueryClassFaker();
	const isEmpty = section.getCount() === 0;
	if(isEmpty) {
		classes.add('is_empty');
	}
	if(section.toggledOn) {
		classes.add('toggled_on');
	}
	else {
		classes.add('toggled_off');
	}
	if(loading) {
		classes.add('loading');
	}
	return (
		<div
			style={style}
			className={`userlist_section_heading ${classes.toString()}`}>
			<span
				className='heading'
				onClick={sectionClick}
			>
				{section.toggledOn && <i className='fa fa-caret-down the_caret' />}
				{!section.toggledOn && <i className='fa fa-caret-right the_caret' />}
				<span className='text'>{section.name}</span>
				{section.getCount() > 10 && <span className='count active'>{section.getCount()}</span>}
			</span>
			{loading && <LoadBar />}
		</div>
	);
}
const defaultProps = {
	loading: false,
};